module.exports = __webpack_public_path__ + "img/normal-quick-link.4e8b1f91.svg";